import React, { useMemo } from "react";
import WebResourceImage from "components/WebResourceImage";
import { UserAvatar } from "components/UserAvatar/UserAvatar";
import { CanotisBOSIco } from "localResouces";
import DirectAccess from "./components/DirectAccess";
import LanguageSelector from "./components/LanguageSelector";
import { getTranslation as translate } from "logic/LocaleManager";

// Externals
import cn from "classnames";

// DevExtreme components
import Toolbar, { Item } from 'devextreme-react/toolbar';

// Component styles
import classes from "./TitleToolbar.module.scss";

function TitleToolbar(props) {
  const {
    isSidebarOpen,
    onToggleShowSidebar,
    title,
    titleImageRef,
    showMainTasks,
    showMainTasksToggle,
    onToggleShowMaintasks,
    disableLaunchpad,
    isAuthenticated,
    userName,
    showDirectAccess,
    navigateTo,
    gotoLaunchpad,
    currentDataSegment,
    currentDataSegmentSessionId,
    disableLanguageSelector
  } = props;

  const sidebarToggleButtonOptionsMemo = useMemo(() => {
    return {
      icon: isSidebarOpen ? 'chevronleft' : 'menu',
      stylingMode: 'text',
      hint: translate("titleToolbar.showHideSidebar", "Show/Hide Sidebar"),
      onClick: () => onToggleShowSidebar(!isSidebarOpen)
    };
  }, [isSidebarOpen]);

  const mainTasksToggleButtonOptionsMemo = useMemo(() => {
    return {
      icon: showMainTasks ? 'chevronup' : 'chevrondown',
      stylingMode: 'text',
      hint: translate("titleToolbar.showHideMaintasks", "Show/Hide Maintasks"),
      onClick: () => onToggleShowMaintasks(!showMainTasks)
    };
  }, [showMainTasks]);

  return (
    <Toolbar className={cn(classes.titleToolbar, "dx-theme-border-color")}>
      <Item
        location="before"
        widget="dxButton"
        options={sidebarToggleButtonOptionsMemo}
        disabled={!isAuthenticated}
      />

      {showMainTasksToggle
        ? (
          <Item
            location="before"
            widget="dxButton"
            options={mainTasksToggleButtonOptionsMemo}
            disabled={!isAuthenticated}
          />
        ) : null
      }

      <Item
        location="before"
        render={() => <WebResourceImage
          size={"30px"}
          fallBackImage={CanotisBOSIco}
          fileId={titleImageRef}
        />
        }
      />

      <Item
        location="before"
        text={title}
      />

      {isAuthenticated && showDirectAccess
        ? (
          <Item
            location="after"
            locateInMenu="auto"
            render={() => <DirectAccess
              hint={translate("titleToolbar.directAccess", "Direct Access")}
              onTaskSelected={(targetUri) => navigateTo(targetUri)}
              currentDataSegment={currentDataSegment}
              currentDataSegmentSessionId={currentDataSegmentSessionId}
            />
            }
          />
        )
        : null
      }

      {isAuthenticated
        ? (
          <Item
            location="after"
            locateInMenu="auto"
            render={() => <LanguageSelector
              hint={translate("titleToolbar.languageSelector", "Language Selector")}
              currentDataSegment={currentDataSegment}
              currentDataSegmentSessionId={currentDataSegmentSessionId}
              disabled={disableLanguageSelector}
            />
            }
          />
        )
        : null
      }

      <Item
        location="after"
        locateInMenu="auto"
        widget="dxButton"
        showText="inMenu"
        options={{
          icon: 'info',
          stylingMode: 'text',
          hint: translate("general.info", "Info"),
          text: translate("general.info", "Info"),
          onClick: () => navigateTo("/about")
        }}
      />

      {(isAuthenticated && !disableLaunchpad)
        ? (
          <Item
            location="after"
            locateInMenu="auto"
            widget="dxButton"
            showText="inMenu"
            options={{
              icon: 'smalliconslayout',
              stylingMode: 'text',
              hint: translate("general.launchpad", "Launchpad"),
              text: translate("general.launchpad", "Launchpad"),
              onClick: () => gotoLaunchpad()
            }}
          />
        ) : null
      }

      {!isAuthenticated
        ? (
          <Item
            location="after"
            widget="dxButton"
            options={{
              icon: 'key',
              hint: translate("general.login", "Login"),
              onClick: () => navigateTo("/login")
            }}
          />
        )
        : null
      }

      {isAuthenticated
        ? (
          <Item
            location="after"
            render={() =>
              <UserAvatar
                userName={userName}
                hint={translate("general.account", "Account")}
                onClicked={() => navigateTo("/account")} />
            }
          />
        )
        : null
      }

      {/* ALWAYS IN MENU */}
      {isAuthenticated
        ? (
          <Item
            locateInMenu="always"
            location="after"
            widget="dxButton"
            options={{
              icon: 'user',
              hint: translate("general.account", "Account"),
              text: translate("general.account", "Account"),
              onClick: () => navigateTo("/account")
            }}
          />
        )
        : null
      }
      {isAuthenticated
        ? (
          <Item
            locateInMenu="always"
            location="after"
            widget="dxButton"
            options={{
              icon: 'preferences',
              hint: translate("general.settings", "Settings"),
              text: translate("general.settings", "Settings"),
              onClick: () => navigateTo("/settings")
            }}
          />
        )
        : null
      }
      {isAuthenticated
        ? (
          <Item
            locateInMenu="always"
            location="after"
            widget="dxButton"
            options={{
              icon: 'export',
              hint: translate("general.logout", "Logout"),
              text: translate("general.logout", "Logout"),
              onClick: () => navigateTo("/logout/1")
            }}
          />
        )
        : null
      }
    </Toolbar>
  );
}

export default (TitleToolbar);

